import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../ui/button';
import { AlertTriangle, ArrowRight } from 'lucide-react';

export const AlertaPrimeirosAtendimentos = ({ especialidade }) => {
  const { api, can } = useAuth();
  const navigate = useNavigate();
  const [n, setN] = useState(null);

  useEffect(() => {
    if (!especialidade || !(can('ver_primeiros_atendimentos') || can('ver_primeiros_atendimentos_todos'))) return;
    let ativo = true;
    api.get('/primeiros-atendimentos/painel', { params: { especialidade } }).then((r) => {
      if (!ativo) return;
      const linhas = r.data?.linhas || [];
      const pend = linhas.flatMap((l) => l.pendencias).filter((p) => p.especialidade === especialidade && ['aguardando_atribuicao', 'aguardando_agendamento', 'agendado'].includes(p.status));
      setN({ total: pend.length, atrasados: pend.filter((p) => p.atrasado).length, agendar: pend.filter((p) => p.status !== 'agendado').length });
    }).catch(() => { if (ativo) setN(null); });
    return () => { ativo = false; };
  }, [api, can, especialidade]);

  if (!n || n.total === 0) return null;
  const cor = n.atrasados ? 'border-rose-300 bg-rose-50 text-rose-900' : 'border-amber-300 bg-amber-50 text-amber-900';
  return (
    <div className={`flex flex-wrap items-center gap-3 rounded-md border px-4 py-3 text-sm ${cor}`} data-testid={`pa-alerta-${especialidade}`}>
      <AlertTriangle className="h-4 w-4 shrink-0" />
      <span className="flex-1">
        <b>{n.total}</b> primeira(s) avaliação(ões) pendente(s) nesta especialidade
        {n.agendar > 0 && <> · <b>{n.agendar}</b> aguardando agendamento</>}
        {n.atrasados > 0 && <> · <b>{n.atrasados}</b> em atraso</>}
      </span>
      <Button size="sm" variant="outline" onClick={() => navigate(`/primeiros-atendimentos?especialidade=${especialidade}`)} data-testid={`pa-alerta-${especialidade}-abrir`}>Ver pendências <ArrowRight className="h-4 w-4 ml-1" /></Button>
    </div>
  );
};
